import { useState, lazy, Suspense, useMemo } from 'react';
import {
  List,
  Divider,
  IconButton
} from '@mui/material';

import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs';
import DocumentItem from '../../../../utils/documentItem';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
const PreviewAnexos = lazy(() => import('../../../../utils/PreviewAnexos'));

export default function DocumentViewer({ pdfUrls = [], urlApi, entidade }) {
  const [editDoc, setEditDoc] = useState(null);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedPdfIndex, setSelectedPdfIndex] = useState(0);

  const handleSelectPdf = (index) => {
    setSelectedPdfIndex(index);
  };

  const DOCUMENTS_CONFIG = [
    { key: 'solicitacao', label: 'Carta Solicitação dirigida à ARMED' },
    { key: 'autorizacaoExportacao', label: 'Autorização de Exportação' },
    { key: 'parecerDNSP', label: 'Parecer da DNSP' },
    { key: 'parecerINLS', label: 'Parecer do INLS' },
    { key: 'copiaValidacao', label: 'Cópia da validação' },
    { key: 'cartaOriginal', label: 'Carta original da unidade hospitalar' },
    { key: 'faturaPro', label: 'Factura Proforma' },
    { key: 'faturaEmolumento', label: 'Factura de emolumento ARMED' },
    { key: 'certificadoBPF', label: 'Certificado BPF (GMP)' },
    { key: 'copiaFI', label: 'Cópia do Folheto Informativo' },
    // Desalfandegamento
    { key: 'faturaFinal', label: 'Factura final' },
    { key: 'cartaPorteBl', label: 'Carta de porte / BL' },
    { key: 'certificadoCQL', label: 'Certificado de controlo de qualidade' },
    { key: 'certificadoOP', label: 'Certificado de Origem' },
    { key: 'copiaCIEA', label: 'Cópia do CIEA' },
    { key: 'folhetoILP', label: 'Folheto informativo' },
    { key: 'receitaMedica', label: 'Receita Médica' },
    { key: 'certificadoProdutoControlado', label: 'Certificado de produto controlado' },
    { key: 'CertificadoAnaliticoLote', label: 'Certificado analítico por lote' },
    { key: 'certificadoExportacao', label: 'Certificado de exportação' },
    { key: 'declaracaoExclusividade', label: 'Declaração de exclusividade' },
    // Medicamentos AIMS
    { key: 'folhetoInformativo', label: 'Folheto Informativo' },
    { key: 'rcm', label: 'RCM' }
  ];

  const documents = useMemo(
    () =>
      Object.entries(pdfUrls)
        .filter(([, url]) => typeof url === 'string' && url.trim() !== '')
        .map(([key, url]) => {
          const config = DOCUMENTS_CONFIG.find(d => d.key === key);

          return {
            key,
            url,
            label: config?.label ?? key
          };
        }),
    [pdfUrls]
  );


  const handlePreview = (file) => {
    // setPreviewFiles(documents);
    // setCurrentFileIndex(documents.indexOf(file));
    // setPreviewOpen(true);
  };

  return (
    <>
      <HeaderGestorConfigs
        configArea="documentos"
        title="DOCUMENTOS ANEXADOS"
      />


      {/* {pdfUrls && <DocumentViewer pdfUrls={pdfUrls} />} */}

      {pdfUrls &&
        <>
          <select
            value={selectedPdfIndex}
            onChange={(e) => handleSelectPdf(parseInt(e.target.value, 10))}
            style={{
              padding: '8px',
              fontSize: '16px',
              borderRadius: '4px',
              maxWidth: '80 % '
              // margin' : '10px',
            }}
          >
            {documents?.map((doc, index) => (
              <option key={index} value={index}>
                {doc.label}
              </option>
            ))}
          </select>

          <IconButton size='large' disabled={selectedPdfIndex < 1} type="submiy" onClick={() => setSelectedPdfIndex(selectedPdfIndex - 1)}>
            <NavigateBeforeIcon />
          </IconButton>

          <IconButton size='large' disabled={selectedPdfIndex === documents?.length - 1} type="submiy" onClick={() => setSelectedPdfIndex(selectedPdfIndex + 1)}>
            <NavigateNextIcon />
          </IconButton>

          {/* <iframe */}
          <embed
            id="pdfIframe"
            title={`PDF Viewer`}
            type="application/pdf"
            src={documents[selectedPdfIndex]?.url}
            width="100%"
            height="600px"
            style={{
              border: 'none'
            }}
          />
        </>
      }


      {/* Lista */}
      {entidade?.status !== 'Aprovado' &&
        <List>
          {documents.map(({ key, label, condition = true }, index) => {
            if (!condition) return null;

            return (
              <div key={key}>
                <DocumentItem
                  url={urlApi}
                  id={entidade?._id}
                  label={label}
                  file={key}
                  docKey={key}
                  // estabelecimentoId={estabelecimento?._id}
                  isEditing={editDoc === key}
                  onToggleEdit={() =>
                    setEditDoc(editDoc === key ? null : key)
                  }
                  onPreview={handlePreview}
                />
                {index < documents.length - 1 && <Divider />}
              </div>
            );
          })}
        </List>
      }


      {/*  Preview Lazy */}
      <Suspense fallback={<p>A carregar preview...</p>}>
        {previewOpen && (
          <PreviewAnexos
            files={previewFiles}
            currentIndex={currentFileIndex}
            isOpen={previewOpen}
            onClose={() => setPreviewOpen(false)}
            onNavigate={setCurrentFileIndex}
          />
        )}
      </Suspense>
    </>
  );
}
